import * as types from './types';
export default {
  [types.SET_CURRENT_LAYER](state, payload) {
    var currentState = state;
    currentState.item = payload.item;
    currentState.index = payload.index;
  },

  [types.SET_LAYER_PRODUCTS](state, payload) {
    var currentState = state;
    currentState.products = payload;
  },

  [types.RESET_LAYER_PRODUCTS](state, payload) {
    var currentState = state;
    currentState.products = payload;
  },

  [types.SET_LOADING_LAYER](state, payload) {
    var currentState = state;
    currentState.loading = payload;
  },

  [types.APPEND_ITEMS](state, payload) {
    var currentState = state;
    currentState.items.push(payload);
  }

};